import { createTheme } from "@mui/material/styles";

import { colors } from "./theme";

/**
 * MUI theme built from the brand tokens in theme.ts.
 *
 * The CSS-variable system in styles/main.css still drives the bespoke visuals
 * (and renders with no flash). This gives us MUI's typed theme — palette,
 * typography, breakpoints — for any MUI components we add later, sourced from
 * the same tokens so the two layers can never drift. Breakpoints mirror the
 * media queries in main.css (520 / 860 / 1180).
 */
export const theme = createTheme({
  palette: {
    mode: "light",
    background: { default: colors.chalk, paper: colors.chalk },
    text: { primary: colors.ink },
    primary: { main: colors.coral, contrastText: colors.ink },
    secondary: { main: colors.aqua, contrastText: colors.ink },
    info: { main: colors.grape, contrastText: colors.chalk },
    warning: { main: colors.sun, contrastText: colors.ink },
  },
  typography: {
    fontFamily: '"Space Grotesk", system-ui, sans-serif',
    fontWeightMedium: 600,
    button: {
      fontFamily: '"Space Mono", ui-monospace, monospace',
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.1em",
    },
  },
  shape: { borderRadius: 8 },
  breakpoints: {
    values: { xs: 0, sm: 520, md: 860, lg: 1180, xl: 1536 },
  },
});
